import { render } from "./CaptureComponent.vue?vue&type=template&id=58958cd8&scoped=true"
import script from "./CaptureComponent.vue?vue&type=script&lang=js"
export * from "./CaptureComponent.vue?vue&type=script&lang=js"

import "./CaptureComponent.vue?vue&type=style&index=0&id=58958cd8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58958cd8"]])

export default __exports__